import HttpClient from "./http-client";

/** System.Tracking.Types (TS.Web.Product.*) — same ids as DatabaseCodebooks. */
export enum ProductEventType {
    CreateDesign = 43003,
    OpenDesign = 43004,
    OpenCalculator = 43005,
    CloseCalculator = 43006,
    AddToCartCalculator = 43007,
    AddToCartDesigner = 43008,
    QuantityUnavailable = 43009,
}

export interface ProductEventPayload {
    type: ProductEventType;
    productModelGuid?: string;
    productVariantGuid?: string;
    calculationGuid?: string;
    printJobGuid?: string;
}

/** Fire-and-forget product funnel event; failures are swallowed (HttpClient no-op handler). */
export async function logProductEvent(payload: ProductEventPayload): Promise<void> {
    try {
        await new HttpClient().fetch(
            "/api/log/product-event",
            {
                method: "POST",
                cache: "no-store",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    type: payload.type,
                    productModelGuid: payload.productModelGuid ?? null,
                    productVariantGuid: payload.productVariantGuid ?? null,
                    calculationGuid: payload.calculationGuid ?? null,
                    printJobGuid: payload.printJobGuid ?? null,
                }),
            },
            () => { /* stats must not interrupt the UX */ }
        );
    } catch {
        /* ignore */
    }
}
